// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4":"982710f4","514":"cd2679d9","778":"c4c4d1b5"}[chunkId] + ".css";
};